import { render, staticRenderFns } from "./WashProductAccessory.vue?vue&type=template&id=4cb6f2f4&scoped=true"
import script from "./WashProductAccessory.vue?vue&type=script&lang=js"
export * from "./WashProductAccessory.vue?vue&type=script&lang=js"
import style0 from "./WashProductAccessory.vue?vue&type=style&index=0&id=4cb6f2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb6f2f4",
  null
  
)

export default component.exports